<template>
  <div class="upload" v-if="seen" :class="{ minimize: minimize }">
    <div class="header blue-bg" ref="body">
      <div>
        {{ getRunningUploads > 0 ? getRunningUploads : getCompletedUploads }}
        upload{{
          getRunningUploads > 0
            ? getRunningUploads > 1
              ? "s"
              : ""
            : getFilesLength > 1
            ? "s"
            : ""
        }}
        {{ hasUploadFinished ? "running" : "completed" }}
      </div>
      <div>
        <span class="minimize" @click="minimize_upload">
          <img src="@/assets/upload-minimize.svg" />
        </span>
        &nbsp;&nbsp;
        <span class="close-upload" @click="close_upload()">
          <img src="@/assets/upload-close.svg" />
        </span>
      </div>
    </div>
    <div class="body">
      <div class="file-upload" v-for="(file, index) in files" :key="index">
        <span>
          <span class="file-name d-flex justify-content-start flex-row">
            <span class="mr-2">
              <img :src="file.getFileIcon" />
            </span>
            <span class="d-flex flex-column text-left">
              <span class="mr-2">{{ str_text(file.name) }}</span>
              <span :class="{ 'file-exists': file.error }" v-if="file.error"
                >File already exist</span
              >
              <template v-if="!file.done && !file.error">
                <span class="uploaded"
                  >{{ $sizeFormat(file.current) }} of
                  {{ $sizeFormat(file.size) }}</span
                >
              </template>
              <template v-else>
                <span class="uploaded">Uploaded</span>
              </template>
            </span>
          </span>
        </span>
        <span
          v-if="!file.done && !file.error && file.isProgress"
          class="upload-actions"
        >
          <span
            class="cancel-upload"
            title="Cancel file upload"
            @click="upload_action(index, 'cancel')"
          >
            <img src="@/assets/upload-item-cancel.svg" />
          </span>
          <span class="pro mt-1" v-show="file.isProgress">
            <template v-if="!file.retry">
              <vue-circle
                :ref="file.id"
                :progress="file.progress"
                :size="30"
                :fill="fill"
                :thickness="4"
                :reverse="true"
                v-show="file.current > 0"
              />
              <img
                src="@/assets/upload-item-loader.gif"
                width="20px"
                height="auto"
                v-if="file.progress == 0"
              />
            </template>
            <template v-else>
              <span @mouseenter="file_hover(file, false)">
                <b-button
                  variant="white"
                  v-b-tooltip.hover
                  title="Retry upload"
                >
                  <svg
                    style="width: 24px; height: 24px; cursor: pointer"
                    viewBox="0 0 24 24"
                    @click="retry(file)"
                  >
                    <path
                      fill="currentColor"
                      d="M2 12C2 16.97 6.03 21 11 21C13.39 21 15.68 20.06 17.4 18.4L15.9 16.9C14.63 18.25 12.86 19 11 19C4.76 19 1.64 11.46 6.05 7.05C10.46 2.64 18 5.77 18 12H15L19 16H19.1L23 12H20C20 7.03 15.97 3 11 3C6.03 3 2 7.03 2 12Z"
                    />
                  </svg>
                </b-button>
              </span>
            </template>
          </span>
        </span>
        <span v-if="file.done && !file.error" class="upload-done">
          <img src="@/assets/Check-Button-Green.svg" width="20px" height="auto" v-show="!file.hover" @mouseenter="file_hover(file, true)" />
          <span @click="gotolocation(file.file_id)" v-show="file.hover" @mouseleave="file_hover(file, false)" style="cursor:pointer">
            <light-folder-icon />
          </span>
        </span>
        <span v-if="file.error" class="upload-done">
          <span class="remove-upload" @click="remove_upload(file.id)">
            <svg style="width: 24px; height: 24px" viewBox="0 0 24 24">
              <path
                fill="#A7B9CB"
                d="M17.65,6.35C16.2,4.9 14.21,4 12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20C15.73,20 18.84,17.45 19.73,14H17.65C16.83,16.33 14.61,18 12,18A6,6 0 0,1 6,12A6,6 0 0,1 12,6C13.66,6 15.14,6.69 16.22,7.78L13,11H20V4L17.65,6.35Z"
              />
            </svg>
          </span>
        </span>
      </div>
    </div>
  </div>
</template>
<style scoped>
.upload .body {
  transition: height 0.15s ease-out;
}

.minimize .body {
  height: 0;
}

.custom-tooltip-container {
  position: relative;
  display: inline-block;
}

.custom-tooltip-container .custom-tooltiptext {
  visibility: hidden;
  background-color: #596a73;
  color: #fff;
  text-align: center;
  border-radius: 3px;
  padding: 2px 5px;
  position: absolute;
  z-index: 1;
  top: 25px;
  opacity: 0;
  transition: opacity 0.5s, padding 0.3s;
  font-size: 12px;
}

.custom-tooltip-container:hover .custom-tooltiptext {
  visibility: visible;
  opacity: 1;
  padding: 5px 10px;
}
.uploaded {
  text-align: left;
  font-size: 12px;
  color: #677888;
}
.upload-actions {
  display: flex;
  justify-content: center;
  align-items: center;
}
.file-upload .fa-file-word {
  color: #054aeb;
}

.file-upload .fa-file-powerpoint {
  color: #fc6d6c;
}

.file-upload .fa-file-pdf {
  color: #eb4e05;
}

.file-upload .fa-file-audio {
  color: #05e3eb;
}

.file-upload .fa-file-video {
  color: #eb0537;
}

.file-upload .fa-file-excel {
  color: #01bc4c;
}
.blue-bg {
  background-color: #102e51;
}
.file-upload .fa-file-powerpoint {
  color: #fc6d6c;
}
.file-upload .fa-file-pdf {
  color: #eb4e05;
}
.file-upload .fa-file-audio {
  color: #05e3eb;
}
.file-upload .fa-file-video {
  color: #eb0537;
}
.file-upload .fa-file-excel {
  color: #01bc4c;
}
</style>

<script>
import {
  connectedObservers,
  connectionObservers,
  uploadObservers,
} from "@/Observers.js";
// import client from 'socket.io-file-stream/dist/web'
import { mapMutations } from "vuex";
import cookies from "@/services/cookies";
import client from "@/services/uploadclient";
import progressIcon from '@/components/Icons/progress-icon.vue'
import VueCircle from 'vue2-circle-progress'
import LightFolderIcon from "@/components/Icons/LightFolderIcon.vue";
import Tooltip from '@/components/Tooltip';
export default {
  components: {
    Tooltip,
    VueCircle,
    LightFolderIcon
  },
  data() {
    return {
      seen: false,
      loader: true,
      minimize: false,
      strokeDashOffset: 0,
      files: {},
      id_length: 8,
      timestamp: new Date(),
      total: "",
      current_id: null,
      fill: { color: "#3f96d1" },
      that: null,
    };
  },
  computed: {
    hasUploadFinished: function () {
      let completed = 0;
      for (let key in this.files) {
        if (!this.files[key].done) {
          completed += 1;
        }
      }
      return completed;
    },
    getFilesLength: function () {
      const arrLength = Object.entries(this.files).length;
      return arrLength;
    },
    getRunningUploads: function () {
      const runningLength = Object.values(this.files).filter(
        (file) => file.done == false
      ).length;
      return runningLength;
    },
    getCompletedUploads: function () {
      const completedLength = Object.values(this.files).filter(
        (file) => file.done == true
      ).length;
      return completedLength;
    },
  },
  methods: {
    ...mapMutations([
      "SET_FILE_ACTION",
      "REMOVE_FILE_ACTION",
      "SET_DIRECTORY_CHILDREN",
      "TOGGLE_FILE_INFO",
      "UPDATE_DIRECTORY_CHILDREN",
      "SORT_STORED_DIRECTORY_CHILDREN",
      "SET_STORED_DIRECTORY_CHILDREN",
      "SORT_DIRECTORY_CHILDREN",
      "UPDATE_TOTAL_USED_SPACE",
      "SET_DIRECTORY_CHILDREN",
      "SET_STORED_DIRECTORY_CHILDREN",
      "SET_PATH",
      "SET_CURRENT_DIRECTORY",
    ]),
    file_hover(file, state) {
      file.hover = state;
    },
    gotolocation(id) {
      this.$parent.loading();
      let that = this;

      let data = {
        id: id,
        token: cookies.getCookie("token"),
      };

      this.$socket.emit("gotolocation", data, function (data) {
        if (data.data === true) {
          localStorage.setItem("current_directory_id", data.dir.id);
          localStorage.setItem("current_directory", data.dir.name);
          localStorage.setItem("db", data.dir.db);
          that.SET_DIRECTORY_CHILDREN(data.directory_children);
          that.SET_STORED_DIRECTORY_CHILDREN(data.directory_children);
          that.SET_CURRENT_DIRECTORY(data.dir.name);
          that.SET_PATH(data.dir_path);

          that.$parent.loading_close();
        }
      });
    },
    _getRandomInt(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
    logincall() {
      this.$parent.logincall();
    },
    generate() {
      var ts = this.timestamp.toString();
      var parts = ts.split("").reverse();
      var id = "";
      for (var i = 0; i < this.id_length; ++i) {
        var index = this._getRandomInt(0, parts.length - 1);
        id += parts[index];
      }
      return id.replace(/[\s\W+]/g, "");
    },
    upload_action(id, action) {
      // uploadObservers.next({ id, action });

      if (action == "cancel") {
        console.log(this.files[id]);
        this.$parent.remove_upload(
          id,
          this.files[id].name + "." + this.files[id].ext
        );
      }
    },
    close_upload() {
      this.total = Object.keys(this.files).length;
      let completed = 0;
      for (let key in this.files) {
        if (!this.files[key].done) {
          completed += 1;
        }
      }
      if (completed) {
        this.$parent.close_upload(completed);
      } else {
        this.seen = false;
        this.files = {};
      }
    },
    remove_file(index) {
      this.files.splice(index, 1);
      if (this.files.length === 0) {
        this.files = [];
        this.minimize = true;
        this.seen = false;
      }
    },
    cancel_uploads() {
      this.files = {};
      this.minimize = true;
      this.seen = false;
    },
    str_text(str) {
      if (str.length > 24) {
        return str.substr(0, 24) + "...";
      }
      return str;
    },
    getName(file) {
      let name = file.split(".");
      let ext = name[name.length - 1];
      name.pop();
      return name.join(".");
    },
    getExt(file) {
      let name = file.split(".");
      let ext = name[name.length - 1];
      return ext;
    },
    getFileIcon(file) {
      let name = file.split(".");
      let ext = name[name.length - 1];

      if (ext.toLowerCase() === "docx" || ext.toLowerCase() === "doc") {
        return require(`@/assets/icons/icon/Doc.svg`);
      }

      if (ext.toLowerCase() === "xlsx" || ext.toLowerCase() === "xls") {
        return require(`@/assets/icons/icon/XLS.svg`);
      }

      if (ext.toLowerCase() === "pptx" || ext.toLowerCase() === "ppt") {
        return require(`@/assets/icons/icon/PPT.svg`);
      }

      if (ext.toLowerCase() === "pdf") {
        return require(`@/assets/icons/icon/PDF.svg`);
      }

      if (ext.toLowerCase() === "mp3") {
        return require(`@/assets/icons/icon/Mp3.svg`);
      }

      if (ext.toLowerCase() === "mp4") {
        return require(`@/assets/icons/icon/video.svg`);
      }

      if (ext.toLowerCase() === "js" || ext.toLowerCase() === "ts") {
        return require(`@/assets/icons/icon/Js.svg`);
      }

      if (ext.toLowerCase() === "php") {
        return require(`@/assets/icons/icon/php.svg`);
      }

      if (ext.toLowerCase() === "psd") {
        return require(`@/assets/icons/icon/Photoshop.svg`);
      }

      if (ext.toLowerCase() === "css") {
        return require(`@/assets/icons/icon/CSS.svg`);
      }

      if (ext.toLowerCase() === "ai") {
        return require(`@/assets/icons/icon/Ai.svg`);
      }

      if (ext.toLowerCase() === "txt") {
        return require(`@/assets/icons/icon/TXT.svg`);
      }

      if (
        ext.toLowerCase() === "rar" ||
        ext.toLowerCase() === "zip" ||
        ext.toLowerCase() === "tar.gz"
      ) {
        return require(`@/assets/icons/icon/Rar.svg`);
      }

      if (
        ext.toLowerCase() === "html" ||
        ext.toLowerCase() === "xhtml" ||
        ext.toLowerCase() === "xml"
      ) {
        return require(`@/assets/icons/icon/HTML.svg`);
      }

      if (
        ext.toLowerCase() === "jpg" ||
        ext.toLowerCase() === "png" ||
        ext.toLowerCase() === "PNG" ||
        ext.toLowerCase() === "jpeg" ||
        ext.toLowerCase() === "JPG" ||
        ext.toLowerCase() === "JPEG" ||
        ext.toLowerCase() === "gif" ||
        ext.toLowerCase() === "GIF"
      ) {
        return require(`@/assets/icons/icon/image.svg`);
      }

      return require(`@/assets/icons/icon/Unkown File.svg`);
    },
    retry(file) {
      console.log(file);
      this.files[file.id].retry = false;
      this.files = { ...this.files };
      this.uploadFile(this.files[file.id].file, file.id);
    },
    load(files, currentId) {
      console.log(files);
      this.minimize = false;
      this.seen = true;
      for (let file of files) {
        this.current_id = currentId;
        let id = this.generate();
        this.getName(file.name);
        this.files[id] = {
          id: id,
          ext: this.getExt(file.name),
          name: this.getName(file.name),
          getFileIcon: this.getFileIcon(file.name),
          isPaused: false,
          isProgress: true,
          progress: 0,
          current: 0,
          size: file.size,
          retry: false,
          done: false,
          error: false,
          hover: false,
          file_id: null,
          file: file,
        };

        this.total = Object.keys(this.files).length;
        this.uploadFile(file, id);
      }
    },
    randomize(a, b) {
      return Math.random() - 0.5;
    },
    remove_upload(id) {
      delete this.files[id];
      this.$forceUpdate();

      this.total = Object.keys(this.files).length;
      if (this.total < 1) {
        this.seen = false;
      }
    },
    do_remove_upload(id) {
      delete this.files[id];
      this.$forceUpdate();

      this.total = Object.keys(this.files).length;
      if (this.total < 1) {
        this.seen = false;
      }
    },
    async uploadFile(file, id) {
      let that = this;
      client.addEventListener("progress", (pro) => {
        let percentage = Math.floor((pro.current / pro.size) * 100);

        that.files[pro.id].progress = percentage;
        that.files[pro.id].current = pro.current;
        that.files[pro.id].size = pro.size;
        that.files = { ...that.files };

        try {
          if (that.$refs[pro.id] != undefined) {
            that.$refs[pro.id][0].updateProgress(percentage);
          }
        } catch (err) {
          console.log(err);
        }
      });

      client.addEventListener("socket-error", (error) => {
        console.log(error);
        console.log(error.type);
        if (error.type == "error") {
          console.log(that.files);
          let keys = Object.keys(that.files);
          console.log(keys);

          for (let key of keys) {
            console.log(key);
            console.log(that.files[key]);
            if (that.files[key].done == false) {
              that.files[key].retry = true;
              that.files = { ...that.files };
            }
          }
        }
      });

      let data = {
        id: id,
        folder_id:
          this.current_id == null
            ? localStorage.getItem("current_directory_id")
            : this.current_id,
      };

      try {
        let res = await client.upload(file, data);
        console.log(res);
        if (res.cloud_id) {
          console.log("finished: " + id);
          console.log(id);
          this.files[id].file_id = res.cloud_id;
          let file_data = {
            token: cookies.getCookie("token"),
            id: res.cloud_id,
            db: that.$store.getters.GET_DB,
            name: file.name,
            size: file.size,
            type: file.type,
            current_directory_id:
              this.current_id == null
                ? localStorage.getItem("current_directory_id")
                : this.current_id,
          };

          this.$socket.emit("upload-slice", file_data, function (data) {
            if (data.data === true) {
              // that.UPDATE_TOTAL_USED_SPACE(total_used_space)
              that.$parent.refreshfolder(false);
              if (
                localStorage.getItem("current_directory_id") == that.current_id
              ) {
                that.UPDATE_DIRECTORY_CHILDREN(data.directory_children);
                that.SORT_DIRECTORY_CHILDREN();
              }

              that.files[id].done = true;
            }
          });
        }
      } catch (err) {
        console.log(err);
        let clientError = await client.getError();
        console.log(clientError);
      }
    },
    minimize_upload() {
      if (!this.minimize) {
        this.minimize = true;
      } else {
        this.minimize = false;
      }
    },
    close() {
      this.seen = false;
    },
    closeSys(evt) {
      if (evt.target.classList[0] === "blockuser") {
        this.seen = false;
      }
    },
  },
  mounted() {
    this.that = this;
  },
};
</script>
